import React from 'react';
import './About.css';
import profile from '../../img/profile.jpg'
import img1 from '../../img/skills/iconfinder_html5_334656.png'
import img2 from '../../img/skills/iconfinder_badge-css-3_317756.png'
import img3 from '../../img/skills/iconfinder_Bootstrap_4923030.png'
import img4 from '../../img/skills/javascript.png'
import img5 from '../../img/skills/react.png'
import img6 from '../../img/skills/iconfinder_mongodb_1012822.png'
import img7 from '../../img/skills/iconfinder_node-js_1269842.png'
import img8 from '../../img/skills/MATERIAL.png'
import img9 from '../../img/skills/iconfinder_google_firebase_1175544.png'
import img10 from '../../img/skills/ku.png'




const About = () => {
    return (
        <div id="about" className="aboutMe">
            <div className="mx-2">
                <h4 className="about-me">About me</h4>

           
            </div>
            <div className="profileImage">
                <img className="profileImage d-flex justify-content-center align-items-center" src={profile} alt=""/>
            </div>
            <div className="text-center mt-5">
                <h2 className="text-light text-element">My name is <span className="name-span"> Shahin Shah</span></h2> <br/>

                <div className="text-center d-flex justify-content-center">
                    <p className="w-40 text-light paragraph-section">Junior Web Developer and hands-on development in the area of the front-end development, And also familiar with CRUD Operation and making dynamic and functional websites using multiple technology tools in the development process, as well as a variety of programming languages, frameworks, and libraries including JavaScript, ES6, React, React Router, React Bootstrap, Material UI. Also familiar with Express JS and MongoDB.
                    Always trying to keep up with any new technology and therefore always trying to learn the newer technologies.</p>
                    

                </div>
                <button className="btn btn-success"><a className="text-light" target="_blank "href="https://drive.google.com/file/d/1gHbgyft2qfZ_Id8IPaAazdY8i1a3B563/view?usp=sharing">See My Resume</a></button>

                <div>
                    <h4  className="py-4 I-am-able text-light mt-5">My Skills</h4>
                    <div className=" p-5"> 
                       <div className="row">
                       <span className="col-md-1"></span>
                            <span className=" span-section span0 py-5 col-md-2">HTML5 <img style={{width:'50px'}} src={img1} alt=""/></span>
                            <span className="span1 span-section py-5  col-md-2">CSS3 <img style={{width:'50px'}} src={img2} alt=""/></span>
                            <span className="span2 span-section py-5  col-md-2">BOOTSTRAP <img style={{width:'50px'}} src={img3} alt=""/></span>
                            <span className="span3 span-section py-5  col-md-2">JAVASCRIPT <img style={{width:'50px'}} src={img4} alt=""/></span>
                            <span className="span4 span-section py-5 col-md-2">REACT <img style={{width:'50px'}} src={img5} alt=""/></span>
                        <span className="col-md-1"></span>
                       </div>

                        <div className="row">
                            <span className="col-md-1"></span>
                            <span className="span5 span-section py-5 col-md-2">MONGODB <img style={{width:'50px'}} src={img6} alt=""/></span>
                            <span className="span6 span-section py-5 col-md-2">NODEJS <img style={{width:'50px'}} src={img7} alt=""/></span>
                            <span className="span7 span-section py-5 col-md-2">MATERIAL UI <img style={{width:'50px'}} src={img8} alt=""/></span>
                            <span className="span8 span-section py-5 col-md-2">FIREBASE <img style={{width:'50px'}} src={img9} alt=""/></span>
                            <span className="span9 span-section py-5 col-md-2">HEROKU <img style={{width:'50px'}} src={img10} alt=""/></span>
                            <span className="col-md-1"></span>
                        </div>

                        
       

{/* here */}
       



                    </div>

                   

       
                    <div>
                
                   
                     

                        
                    </div>

                    
                </div>

           







            </div>
            <hr/>





               


            

            
        </div>
    );
};

export default About;